import { BaseEdge } from '@xyflow/react';

export default function StubEdge({ id, sourceX, sourceY, targetX, targetY,
    _sourcePosition, _targetPosition, style, markerEnd }) {
    // Build an SVG path string for a simple straight line
    const path = `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;

    return (
        <BaseEdge
            id={id}
            path={path}
            markerEnd={markerEnd}
            style={style}
            interactionWidth={0}
        />
    );
}
